import { extractEnvironment } from "src/app/features/version.feature";
import { env } from "./env.tool";

export function isEnv(envValue: "BETA" | "STAGING" | "DEV") {
  const envUrl = env("VITE_GRAPHQL_ENDPOINT");
  const envName = extractEnvironment(envUrl)?.toUpperCase();

  return envName === envValue;
}
